import { Flex } from '@mantine/core'
import React, { useContext } from 'react'

import {
  useMutationCreateUserAddress,
  useMutationUpdateUserAddress,
} from '@flecto/core/shared'
import { useTranslation } from '@flecto/translations'
import { type ParameterID, type CoreUserAddress } from '@flecto/types'
import { Modal, ModalsContext } from '@flecto/ui'

import { AddressForm } from '../../../profile-address/components/AddressForm/AddressForm'

export type ModalAddressProps = {
  addressId?: ParameterID
  onSuccess?: (address: CoreUserAddress) => void
}

export function ModalAddress({ addressId, onSuccess }: ModalAddressProps) {
  const { t } = useTranslation('saas', {
    keyPrefix: 'profile_locations',
  })
  const { closeModal } = useContext(ModalsContext)

  const { isLoading: isLoadingCreate } = useMutationCreateUserAddress()
  const { isLoading: isLoadingUpdate } = useMutationUpdateUserAddress()

  const title = addressId ? t('title_update') : t('title_create')

  return (
    <Modal variant='default' size='xxl'>
      <Modal.Close />
      <Modal.Title>
        <Flex gap={'sm'} align={'flex-end'}>
          {title}
        </Flex>
      </Modal.Title>
      <Modal.Content>
        <AddressForm
          id='address-form'
          onSuccess={(data) => onSuccess?.(data)}
          isModal
          closeModal={closeModal}
        />
      </Modal.Content>

      <Modal.Cancel />
      <Modal.Submit
        type='submit'
        form='address-form'
        preventClose
        loading={isLoadingCreate || isLoadingUpdate}
      />
    </Modal>
  )
}
